import {
	Component,
	OnInit,
	ChangeDetectionStrategy,
	ViewChild,
	ChangeDetectorRef,
	OnDestroy
} from '@angular/core';
import {
	CalendarDateFormatter,
	CalendarEvent,
	CalendarView,
	DAYS_OF_WEEK
} from 'angular-calendar';
import { WeekViewHourSegment } from 'calendar-utils';
import { Solution } from 'src/app/shared/models/solution';
import { CustomDateFormatter } from 'src/app/shared/utils/custom-date-formatter';
import { MISSION_TYPE_REUNION_TYPE } from 'src/app/core/services/constant/constants.service';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { ExportPdfUtils } from 'src/app/shared/utils/export-pdf-utils';
import { EventEditComponent } from '../event-edit/event-edit.component';
import { BuildSolutionComponent } from '../build-solution/build-solution.component';
import { fromEvent, Subject, Subscription } from 'rxjs';
import { addDays, addMinutes, endOfWeek } from 'date-fns';
import { Mission } from 'src/app/shared/models/mission/mission';
import { Vacation, VacationType } from 'src/app/shared/models/vacation';
import { finalize, takeUntil } from 'rxjs/operators';
import { ConvertObjectToCalendarEvent } from 'src/app/shared/utils/convert-object-to-calendar-event';
import { CreateVacationComponent } from '../create-vacation/create-vacation.component';
import { User } from 'src/app/shared/models/security/user';
import { LogService } from 'src/app/core/services/log/log.service';
import { NavbarPlanningComponent } from '../navbar-planning/navbar-planning.component';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Employee } from 'src/app/shared/models/employee/employee';
import { CenterType } from 'src/app/shared/enums/center-type.enum';
import { Authority } from 'src/app/shared/models/security/authority';
import {
	EventBusService,
	OptimEventData
} from 'src/app/core/services/event-bus/event-bus.service';
import { Beneficiaire } from 'src/app/shared/models/beneficiaire';
import { Notification } from 'src/app/shared/models/notification';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { MissionType } from 'src/app/shared/models/mission/mission-type';
import { PlanningInformation } from 'src/app/shared/models/custom/planning-information';
import { MissionPlace } from 'src/app/shared/models/mission/mission-place';
import {
	CompetencesElementaires,
	getCompetencesByCenterType
} from 'src/app/shared/enums/competence.enum';
import { CenterDepartment } from 'src/app/shared/models/center-department';

@Component({
	selector: 'app-planning',
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: './planning.component.html',
	styleUrls: ['./planning.component.scss'],
	providers: [
		{ provide: CalendarDateFormatter, useClass: CustomDateFormatter },
		{ provide: DateUtils, useClass: DateUtils },
		{ provide: ExportPdfUtils, useClass: ExportPdfUtils },
		{
			provide: ConvertObjectToCalendarEvent,
			useClass: ConvertObjectToCalendarEvent
		}
	]
})
export class PlanningComponent implements OnInit, OnDestroy {
	listViewEvent: any;
	constructor(
		public dateUtils: DateUtils,
		public exportPdfUtils: ExportPdfUtils,
		private cdr: ChangeDetectorRef,
		protected convertObjectToCalEv: ConvertObjectToCalendarEvent,
		private logger: LogService,
		private facade: FacadeService,
		private eventBusService: EventBusService
	) {}

	@ViewChild(CreateVacationComponent) createAbsence: CreateVacationComponent;
	@ViewChild(EventEditComponent) eventEdit: EventEditComponent;
	@ViewChild(BuildSolutionComponent) buildSolution: BuildSolutionComponent;
	@ViewChild(NavbarPlanningComponent) navbarPlanning: NavbarPlanningComponent;
	// Calendar Vars
	view: CalendarView;
	CalendarView = CalendarView;
	selectedCalendarDate: Date = new Date();
	selectedWeek: number;
	selectedYear: number;
	beginDate: Date;
	endDate: Date;
	locale = 'fr';
	weekStartsOn: number = DAYS_OF_WEEK.MONDAY;
	weekendDays: number[] = [DAYS_OF_WEEK.SATURDAY, DAYS_OF_WEEK.SUNDAY];
	dayStartHour = this.facade.dataStorageService.getParamMinDay();
	dayEndHour = this.facade.dataStorageService.getParamMaxDay();
	excludeDays: number[] = [0, 6];
	hourSegments = 2;
	hourSegmentsMin = 1;
	hourSegmentsMax = 15;
	// for aligned view
	nbDayToDisplay = 5;

	// Vars
	solution: Solution;
	solutions: Solution[] = []; // only for month view
	employeesList: Employee[] = [];

	refreshInProgress = false;

	currentLoggedInEmployeeId: number;
	currentUserAuthority: number;
	currentUser: User;
	// Tout ce qui est utilisé par le planning, vue non alignée
	events: CalendarEvent[] = [];

	refresh: Subject<void> = new Subject<void>();
	activeDayIsOpen = true;
	dragToCreateActive = false;

	dragToSelectEvent: CalendarEvent = null;

	isMobile = false;

	isModeListActive = { active: false };
	isModeAvailabilityActive = { active: false };

	competences: any = CompetencesElementaires;

	vacationTypes: VacationType[] = [];

	isSESSAD = false;
	isSAAD = false;
	isSSIAD = false;

	listViewableCenters: { id: number; name: string; type: number }[] = [];
	selectedCenter: { id: number; name: string; type: number } = null;
	//Le planning est editable si l'utilisateur est dans le même centre que le planning visualisé
	isPlanningEditable = true;
	isPlanificatrice = false;

	isLoadingSolution: boolean;
	eventBusSub?: Subscription;

	subscriptions: Subscription[] = [];

	listBeneficiaires: Beneficiaire[] = [];
	listMissionTypes: MissionType[] = [];
	listMissionPlaces: MissionPlace[] = [];
	listCenterDepartments: CenterDepartment[] = [];

	// Le temps minimal (en minutes) de disponibilité requis pour que la dispo apparaîsse dans le planning des dispos
	MINIMAL_TIME_FOR_AVAILABILITY = 60;

	// Est ce qu'on autorise les users à accéder au planning des dispos
	canDisplayAvailabilityPlanning = false;

	isEventBusLaunched = false;

	daysFr = [
		'Dimanche',
		'Lundi',
		'Mardi',
		'Mercredi',
		'Jeudi',
		'Vendredi',
		'Samedi'
	];

	dataForWeekViewAligned: {
		date: Date;
		isHoliday: boolean;
		employees: Employee[];
		events: CalendarEvent[];
	}[] = [];

	eventsStore: {
		assignedMissions: CalendarEvent[];
		unassignedMissions: CalendarEvent[];
		routes: CalendarEvent[];
		vacations: CalendarEvent[];
		holidays: CalendarEvent[];
		availabilities: CalendarEvent[];
	} = {
		assignedMissions: [],
		unassignedMissions: [],
		routes: [],
		vacations: [],
		holidays: [],
		availabilities: []
	};

	isWeekViewAlignedActive = true; // par défaut la vue alignée est activée

	ngOnInit(): void {
		this.initializeVariables();

		this.getDataForPlanning({
			dateToLoad: this.selectedCalendarDate,
			reloadEmployeesAndVacation: true,
			reloadSolution: true,
			reloadOptimInProgress: true,
			reloadVacationTypes: true
		});

		this.launchEventBusSubscription();

		this.canDisplayAvailabilityPlanning =
			this.facade.dataStorageService.getParamAvailabilityPlanningActive();
	}

	ngOnDestroy(): void {
		if (this.eventBusSub) this.eventBusSub.unsubscribe();
		this.subscriptions.forEach((sub) => sub.unsubscribe());
	}

	initializeVariables(): void {
		this.isMobile =
			this.facade.mobileService.isMobile() || window.innerWidth < 1200;
		if (this.isMobile) {
			this.nbDayToDisplay = 1;
		}
		this.view = CalendarView.Week;

		this.currentUser = this.facade.dataStorageService.getUser();

		this.isPlanificatrice =
			this.currentUser?.role.id === Authority.PLANIFICATEUR;

		this.isSESSAD = this.facade.dataStorageService.isSESSAD();
		this.isSAAD = this.facade.dataStorageService.isSAAD();
		this.isSSIAD = this.facade.dataStorageService.isSSIAD();

		this.currentUserAuthority = this.currentUser?.role.id;

		this.currentLoggedInEmployeeId = this.currentUser?.employee?.id;

		if (this.facade.dataStorageService.getParam('storedCalendarWeeknumber')) {
			this.selectedWeek = this.facade.dataStorageService.getParam(
				'storedCalendarWeeknumber'
			);
			if (this.facade.dataStorageService.getParam('storedCalendarYearnumber')) {
				this.selectedYear = this.facade.dataStorageService.getParam(
					'storedCalendarYearnumber'
				);
			} else {
				this.selectedYear = new Date().getFullYear();
			}
			this.selectedCalendarDate = this.dateUtils.getMonday(
				this.dateUtils.getDateOfISOWeek(this.selectedWeek, this.selectedYear)
			);
		} else {
			this.selectedWeek = this.dateUtils.getWeekNumber(
				this.selectedCalendarDate
			);
			this.selectedYear = new Date().getFullYear();
		}
		// this.setDatesOfWeek();

		//Récupération des centres dans le localStorage pour l'affichage dans le sélecteur
		if (
			this.facade.dataStorageService.getParam('listCenterViewableInPlanning')
		) {
			this.listViewableCenters = this.facade.dataStorageService.getParam(
				'listCenterViewableInPlanning'
			) as { id: number; name: string; type: number }[];

			//Si seul le centre de l'utilisateur on vide la liste afin de ne pas afin le sélecteur dans la vue
			if (
				this.listViewableCenters.length === 1 &&
				this.listViewableCenters.every(
					(center) => center.id === this.currentUser?.employee.serviceCenter.id
				)
			) {
				this.listViewableCenters = [];
			}
		} else {
			this.listViewableCenters = [];
		}
		this.selectedCenter = this.listViewableCenters.find(
			(center) =>
				center.id ===
				this.facade.dataStorageService.getUser()?.employee.serviceCenter.id
		);
		if (this.selectedCenter) {
			this.competences = getCompetencesByCenterType(this.selectedCenter.type);
		}
	}

	launchEventBusSubscription() {
		if (!this.isEventBusLaunched) {
			this.eventBusSub = this.eventBusService.on(
				'getIsOptimInProgressFromNavbar',
				(optimEvent: OptimEventData) => {
					// Si on a une optim pour la semaine en train d'être regarder par l'utilisateur
					if (optimEvent?.weekNumber === this.solution?.weekNumber) {
						// et que this.isLoadingSolution n'est pas déjà à true alors qu'une optim est en cours
						if (!this.isLoadingSolution && optimEvent.isOptimInProgress) {
							this.setIsLoadingSolutionAndTriggerChangeDetection(true);
						}
						// ou qu'une optim est terminé et isLoadingSolution n'est pas encore à false
						else if (this.isLoadingSolution && !optimEvent.isOptimInProgress) {
							this.setIsLoadingSolutionAndTriggerChangeDetection(false);
							// si optim_multiple actif : on ouvre la modale de choix de solution
							if (this.facade.dataStorageService.isOptimMultipleActive()) {
								this.navbarPlanning?.getTemporaryOptimReports();
							} else {
								// sinon : on recharge la solution calculée
								this.getDataForPlanning({
									dateToLoad: this.selectedCalendarDate,
									reloadEmployeesAndVacation: false,
									reloadSolution: true,
									reloadOptimInProgress: true,
									busUnsubscribe: true
								});
							}
						}
					}
				}
			);
			this.isEventBusLaunched = true;
		} else {
			this.logger.error('eventBus already launched !');
		}
	}

	selectedCenterChange(center: { id: number; name: string; type: number }) {
		this.selectedCenter = center;
		this.isPlanningEditable =
			this.selectedCenter.id === this.currentUser?.employee.serviceCenter.id;
		if (this.selectedCenter) {
			this.competences = getCompetencesByCenterType(this.selectedCenter.type);
		}
		this.getDataForPlanning({
			dateToLoad: this.selectedCalendarDate,
			reloadEmployeesAndVacation: true,
			reloadSolution: true,
			reloadOptimInProgress: false
		});
	}

	/**
	 * Change la vue du planning active, désactive le mode liste et raffraichit les données
	 * @param view Vue du calendar
	 */
	setView(view: CalendarView) {
		this.isModeListActive.active = false;
		this.isModeAvailabilityActive.active = false;
		this.view = view;
		if (this.view !== CalendarView.Day && !this.isWeekViewAlignedActive) {
			if (
				this.employeesList.findIndex(
					(emp) => emp.firstName === 'Non' && emp.lastName === 'affectées'
				) !== -1
			) {
				this.employeesList.pop();
			}
		}
		this.refreshView();
	}

	setAlignedView(view?: string) {
		if (view && view.includes('aligned-view')) {
			this.isWeekViewAlignedActive = true;
		} else {
			this.isWeekViewAlignedActive = false;
		}
	}

	/**
	 * Retire le/les type d'events indiqués du planning
	 *
	 * @param eventTypeToRemove
	 */
	cleanPlanning(eventTypeToRemove?: string) {
		if (this.isWeekViewAlignedActive) {
			if (eventTypeToRemove && eventTypeToRemove.includes('temp')) {
				this.dataForWeekViewAligned.forEach((data) => {
					data.events = data.events.filter(
						(event) => event.meta?.type !== 'temp'
					);
				});
				this.logger.log('cleanTempVacationOfPlanning !');
			}
			if (eventTypeToRemove && eventTypeToRemove.includes('vacation')) {
				this.dataForWeekViewAligned.forEach((data) => {
					data.events = data.events.filter(
						(event) => event?.meta?.type !== 'vacation'
					);
				});
				this.logger.log('cleanVacationOfPlanning !');
			}
			if (eventTypeToRemove && eventTypeToRemove.includes('route')) {
				// on filtre les routes + missions unassigned
				this.dataForWeekViewAligned.forEach((data) => {
					data.events = data.events.filter(
						(event) =>
							event?.meta?.type !== 'route' &&
							event?.meta?.type !== 'mission' &&
							!event?.meta?.employee
					);
				});
				this.logger.log('cleanRouteOfPlanning() !');
			}
			if (eventTypeToRemove && eventTypeToRemove.includes('mission')) {
				this.dataForWeekViewAligned.forEach((data) => {
					data.events = data.events.filter(
						(event) => event?.meta?.type !== 'mission'
					);
				});
				this.logger.log('cleanMissionOfPlanning() !');
			}
			if (eventTypeToRemove && eventTypeToRemove.includes('availability')) {
				this.dataForWeekViewAligned.forEach((data) => {
					data.events = data.events.filter(
						(event) =>
							event?.meta?.type !== 'availability' &&
							event?.meta?.type !== 'allDayAvailability'
					);
				});
				this.logger.log('cleanAvailabilityOfPlanning() !');
			}

			if (!eventTypeToRemove || eventTypeToRemove === '') {
				this.dataForWeekViewAligned.forEach((data) => {
					data.events = [];
				});
				this.logger.log('cleanPlanning() !');
			}
		} else {
			if (eventTypeToRemove && eventTypeToRemove.includes('temp')) {
				this.events = this.events.filter(
					(event) => event.meta?.type !== 'temp'
				);
				this.logger.log('cleanTempVacationOfPlanning !');
			}
			if (eventTypeToRemove && eventTypeToRemove.includes('vacation')) {
				this.events = this.events.filter(
					(event) => event?.meta?.type !== 'vacation'
				);
				this.logger.log('cleanVacationOfPlanning !');
			}
			if (eventTypeToRemove && eventTypeToRemove.includes('route')) {
				// on filtre les routes + missions unassigned
				this.events = this.events.filter(
					(event) =>
						event?.meta?.type !== 'route' &&
						event?.meta?.type !== 'mission' &&
						!event?.meta?.employee
				);
				this.logger.log('cleanRouteOfPlanning() !');
			}
			if (eventTypeToRemove && eventTypeToRemove.includes('mission')) {
				this.events = this.events.filter(
					(event) => event?.meta?.type !== 'mission'
				);
				this.logger.log('cleanMissionOfPlanning() !');
			}
			if (eventTypeToRemove && eventTypeToRemove.includes('availability')) {
				this.events = this.events.filter(
					(event) =>
						event?.meta?.type !== 'availability' &&
						event?.meta?.type !== 'allDayAvailability'
				);
				this.logger.log('cleanAvailabilityOfPlanning() !');
			}

			if (!eventTypeToRemove || eventTypeToRemove === '') {
				this.events = [];
				this.logger.log('cleanPlanning() !');
			}
		}

		this.refresh.next();
	}

	addPublicHolidaysToCalendarEvent() {
		const holidaysEvents = this.convertObjectToCalEv.loadPublicHolidays();

		const holidaysEventsFiltered =
			this.events.findIndex((event) => event.meta.type === 'holiday') > -1
				? []
				: holidaysEvents;

		this.events = [...this.events, ...holidaysEventsFiltered];
	}

	isAbsenceSwitchActive() {
		return (
			this.navbarPlanning?.isAbsenceSwitchActive ||
			(JSON.parse(
				this.facade.dataStorageService.getParam('storedAbsenceSwitchActive')
			) as boolean) === true
		);
	}

	isViewTourneeSwitchActive() {
		return this.navbarPlanning?.isViewTourneesSwitchActive;
	}

	setEmployeesToRoutes() {
		// on set les employés dans les routes
		this.solution.plannings.forEach((planning) => {
			planning.routes.forEach((route) => {
				if (!route.employee) {
					route.employee = planning.employee;
				}
			});
		});
	}

	setEmployeesToMissions() {
		// on set les employés dans les missions
		this.solution.plannings.forEach((planning) => {
			planning.routes
				.flatMap((route) => route.missions)
				.forEach((mission) => (mission.assignedEmployee = planning.employee));
		});
	}

	storeEvents() {
		this.logger.info('storeEvents');
		this.resetStoreEvents();
		this.storeEventsAssignedMissions();
		this.storeEventsUnassignedMissions();
		this.storeEventsRoutes();
		this.storeEventsVacations();
		this.storeEventsHolidays();
	}

	resetStoreEvents() {
		this.eventsStore = {
			assignedMissions: [],
			unassignedMissions: [],
			routes: [],
			vacations: [],
			holidays: [],
			availabilities: []
		};
	}

	storeEventsAssignedMissions() {
		this.setEmployeesToMissions();
		const assignedMissionsEvents: CalendarEvent[] = this.solution.plannings
			.flatMap((planning) => planning.routes)
			.flatMap((route) => route.missions)
			.map((mission) =>
				this.convertObjectToCalEv.convertMissionToCalendarEvent(mission)
			)
			.flatMap((travelAndMissionEvent) => travelAndMissionEvent);
		this.eventsStore.assignedMissions = assignedMissionsEvents;
	}

	storeEventsUnassignedMissions() {
		const unassignedMissionsEvents: CalendarEvent[] =
			this.solution.unassignedMissions
				.map((mission) =>
					this.convertObjectToCalEv.convertMissionToCalendarEvent(mission)
				)
				.flatMap((travelAndMissionEvent) => travelAndMissionEvent);
		this.eventsStore.unassignedMissions = unassignedMissionsEvents;
	}

	storeEventsRoutes() {
		this.setEmployeesToRoutes();
		const routesEvents: CalendarEvent[] = this.solution.plannings
			.flatMap((planning) => planning.routes)
			.filter((route) => route.missions.length > 0)
			.map((route) =>
				this.convertObjectToCalEv.convertRouteToCalendarEvent(
					route,
					route.employee
				)
			);
		this.eventsStore.routes = routesEvents;
	}

	storeEventsVacations() {
		const vacationsEvents: CalendarEvent[] = this.employeesList.flatMap((emp) =>
			this.convertObjectToCalEv.convertAbsencesItfcToCalendarEvent(emp)
		);
		this.eventsStore.vacations = vacationsEvents;
	}

	storeEventsHolidays() {
		const holidaysEvents: CalendarEvent[] =
			this.convertObjectToCalEv.loadPublicHolidays();
		this.eventsStore.holidays = holidaysEvents;
	}

	/**
	 * ABSENCES
	 */
	displayVacations() {
		if (this.isAbsenceSwitchActive() && !this.isModeAvailabilityActive.active) {
			this.logger.debug('displayVacations');
			let vacationEvents: CalendarEvent[] = [];
			const displayForAllEmps: boolean =
				this.navbarPlanning?.ddEmployee === this.navbarPlanning?.defaultText;
			const displayForCareSkill: boolean =
				!displayForAllEmps && this.navbarPlanning?.selectedCompetenceInDropdown;
			const displayForEmp =
				!displayForAllEmps && this.navbarPlanning?.selectedEmployeeInDropdown;
			if (displayForAllEmps) {
				// Afficher les absences pour tous les employés
				vacationEvents.push(...this.eventsStore.vacations);
			} else if (displayForCareSkill) {
				// Afficher absences pour careSkill sélectionné
				vacationEvents.push(
					...this.eventsStore.vacations.filter((eventVacation) =>
						eventVacation.meta.employee.careSkill?.name.includes(
							this.navbarPlanning.selectedCompetenceInDropdown.key
						)
					)
				);
			} else if (displayForEmp) {
				// Afficher absences pour employé sélectionné
				vacationEvents.push(
					...this.eventsStore.vacations.filter(
						(eventVacation) =>
							eventVacation.meta.employee.id ===
							this.navbarPlanning.selectedEmployeeInDropdown.id
					)
				);
			}
			// récupération des ids des absences existantes dans les calendarEvent
			const vacationIdsAlreadyDisplayed: number[] = this.isWeekViewAlignedActive
				? this.dataForWeekViewAligned
						.flatMap((data) => data.events)
						.filter((vacEvent) => vacEvent.meta?.type === 'vacation')
						.map((vacEvent) => vacEvent.meta?.vacation.id)
				: this.events
						.filter((vacEvent) => vacEvent.meta?.type === 'vacation')
						.map((vacEvent) => vacEvent.meta?.vacation.id);
			// on filtre les doublons
			vacationEvents = vacationEvents.filter(
				(vacEvent) =>
					vacationIdsAlreadyDisplayed.indexOf(vacEvent.meta.vacation.id) === -1
			);
			// Mise à jour de la liste des événements
			if (this.isWeekViewAlignedActive) {
				vacationEvents.forEach((abs) => {
					// Si l'absence ne dure qu'une journée, on ne l'affiche que dans une colonne
					if (abs.start.getDay() === abs.end.getDay()) {
						const dataForDay = this.dataForWeekViewAligned.find(
							(data) => data.date.getDay() === abs.start.getDay()
						);
						dataForDay.events = [...dataForDay.events, abs];
					} else {
						// Sinon, si elle dure plusieurs jours, on l'ajoute à plusieurs colonnes
						for (let day = abs.start.getDay(); day <= abs.end.getDay(); day++) {
							const dataForDay = this.dataForWeekViewAligned.find(
								(data) => data.date.getDay() === day
							);
							dataForDay.events = [...dataForDay.events, abs];
						}
					}
				});
			} else {
				this.events = [...this.events, ...vacationEvents];
			}
		} else {
			this.cleanPlanning('vacation');
		}
	}

	/**
	 * SOLUTION
	 */
	displaySolution() {
		this.logger.debug('displaySolution');
		let solutionEvents: CalendarEvent[] = [];
		const displayForAllEmps: boolean =
			this.navbarPlanning?.ddEmployee === this.navbarPlanning?.defaultText;
		const displayForCareSkill: boolean =
			!displayForAllEmps && this.navbarPlanning?.selectedCompetenceInDropdown;
		const displayForEmp =
			!displayForAllEmps && this.navbarPlanning?.selectedEmployeeInDropdown;
		const displayForMissionType =
			displayForAllEmps && this.navbarPlanning?.selectedMissionType;
		const displayForBenef =
			displayForAllEmps && this.navbarPlanning?.selectedBeneficiaireInFilter;
		const displayForMissionPlace =
			displayForAllEmps && this.navbarPlanning?.selectedMissionPlace;
		const displayForCenterDepartment =
			displayForAllEmps && this.navbarPlanning?.selectedCenterDepartment;
		if (!this.isViewTourneeSwitchActive()) {
			// vue tournée : on récupère les routesEvents && unassignedMissionsEvents du store
			// on commence par vider les events de type mission
			this.cleanPlanning('mission_availability_route');
			if (displayForAllEmps) {
				// Afficher les routes pour tous les employés
				solutionEvents.push(
					...this.eventsStore.routes,
					...this.eventsStore.unassignedMissions
				);
			} else if (displayForCareSkill) {
				// Afficher les routes pour les employés possédant le careSkill sélectionné
				solutionEvents.push(
					...this.eventsStore.routes.filter((routeEvent) =>
						routeEvent.meta.employee.careSkill?.name.includes(
							this.navbarPlanning.selectedCompetenceInDropdown.key
						)
					)
				);
				// également les missions non assignées si existantes
				solutionEvents.push(
					...this.eventsStore.unassignedMissions.filter((missionEvent) =>
						missionEvent.meta.missionRequest?.careSkill.name.includes(
							this.navbarPlanning.selectedCompetenceInDropdown.key
						)
					)
				);
			} else if (displayForEmp) {
				// Afficher uniquement les routes de l'employé sélectionné
				solutionEvents.push(
					...this.eventsStore.routes.filter(
						(routeEvent) =>
							routeEvent.meta.employee.id ===
							this.navbarPlanning.selectedEmployeeInDropdown.id
					)
				);
			} else if (
				displayForMissionType ||
				displayForBenef ||
				displayForCenterDepartment
			) {
				// pas de route pour le filtre missionType ni pour le beneficiaire.
			}
			// filtre des routes doublons
			const eventsListToCheck: CalendarEvent[] = this.isWeekViewAlignedActive
				? this.dataForWeekViewAligned.flatMap((data) => data.events)
				: this.events;
			const routeIdsAlreadyDisplayed: number[] = eventsListToCheck
				.filter((routeEvent) => routeEvent && routeEvent.meta?.type === 'route')
				.map((routeEvent) => routeEvent.meta?.route?.id);
			const missionIdsAlreadyDisplayed: number[] = eventsListToCheck
				.filter(
					(missionEvent) =>
						missionEvent && missionEvent.meta?.type === 'mission'
				)
				.map((missionEvent) => missionEvent.meta?.mission?.id);
			solutionEvents = solutionEvents.filter(
				(event) =>
					event &&
					((event.meta?.type === 'route' &&
						routeIdsAlreadyDisplayed.indexOf(event.meta.route.id) === -1) ||
						(event.meta?.type === 'mission' &&
							missionIdsAlreadyDisplayed.indexOf(event.meta.mission.id) === -1))
			);
			// Filtre pour les missions groupées (synched) => la mission groupée ne doit pas apparaître dans la route de la planificatrice
			solutionEvents = solutionEvents.filter(
				(event) =>
					!(
						event.meta?.type === 'route' &&
						(event.meta.route.missions as Mission[]).findIndex(
							(mission) => mission.attendees
						) > -1
					)
			);
		} else {
			// vue classique : on récupère les missionsEvents du store
			// on commence par vider les events de type route
			this.cleanPlanning('route');
			if (
				displayForAllEmps &&
				!displayForMissionType &&
				!displayForBenef &&
				!displayForMissionPlace &&
				!displayForCenterDepartment
			) {
				// Afficher les missions pour tous les employés
				solutionEvents.push(
					...this.eventsStore.assignedMissions,
					...this.eventsStore.unassignedMissions
				);
			} else if (displayForCareSkill) {
				// Afficher les missions pour les employés possédant le careSkill sélectionné
				solutionEvents.push(
					...this.eventsStore.assignedMissions.filter((missionEvent) =>
						missionEvent.meta.employee.careSkill?.name.includes(
							this.navbarPlanning.selectedCompetenceInDropdown.key
						)
					)
				);
				solutionEvents.push(
					...this.eventsStore.unassignedMissions.filter((missionEvent) =>
						missionEvent.meta.mission.missionRequest?.careSkill?.name.includes(
							this.navbarPlanning.selectedCompetenceInDropdown.key
						)
					)
				);
			} else if (displayForEmp) {
				// Afficher uniquement les missions de l'employé sélectionné
				solutionEvents.push(
					...this.eventsStore.assignedMissions.filter(
						(missionEvent) =>
							missionEvent.meta.employee.id ===
							this.navbarPlanning.selectedEmployeeInDropdown.id
					)
				);
			} else if (displayForMissionType) {
				// Afficher uniquement les missions du type de mission sélectionné
				const filterMissionType = (missionEvent: CalendarEvent) =>
					missionEvent.meta.mission.missionRequest?.missionType.type ===
					this.navbarPlanning.selectedMissionType.type;
				solutionEvents.push(
					...this.eventsStore.assignedMissions.filter(filterMissionType)
				);
				// Missions non affectées
				solutionEvents.push(
					...this.eventsStore.unassignedMissions.filter(filterMissionType)
				);
			} else if (displayForBenef) {
				// Afficher uniquement les missions du bénéficiaire sélectionné
				const filterBenef = (missionEvent: CalendarEvent) =>
					missionEvent.meta.mission.missionRequest?.beneficiaire?.id ===
					this.navbarPlanning.selectedBeneficiaireInFilter.id;
				solutionEvents.push(
					...this.eventsStore.assignedMissions.filter(filterBenef)
				);
				// Missions non affectées
				solutionEvents.push(
					...this.eventsStore.unassignedMissions.filter(filterBenef)
				);
			} else if (displayForMissionPlace) {
				// Afficher uniquement les missions de la missionPlace sélectionnée
				const filterMissionPlace = (missionEvent: CalendarEvent) =>
					missionEvent.meta.mission.missionRequest?.missionPlace?.id ===
					this.navbarPlanning.selectedMissionPlace.id;
				solutionEvents.push(
					...this.eventsStore.assignedMissions.filter(filterMissionPlace)
				);
				// Missions non affectées
				solutionEvents.push(
					...this.eventsStore.unassignedMissions.filter(filterMissionPlace)
				);
			} else if (displayForCenterDepartment) {
				// Afficher uniquement les missions du type de mission sélectionné
				const filterCenterDepartment = (missionEvent: CalendarEvent) =>
					missionEvent.meta.mission.missionRequest?.centerDepartment?.id ===
					this.navbarPlanning.selectedCenterDepartment.id;
				solutionEvents.push(
					...this.eventsStore.assignedMissions.filter(filterCenterDepartment)
				);
				// Missions non affectées
				solutionEvents.push(
					...this.eventsStore.unassignedMissions.filter(filterCenterDepartment)
				);
			}

			// filtre des missions doublons
			const eventsListToCheck: CalendarEvent[] = this.isWeekViewAlignedActive
				? this.dataForWeekViewAligned.flatMap((data) => data.events)
				: this.events;
			const missionIdsAlreadyDisplayed: number[] = eventsListToCheck
				.filter((missionEvent) => missionEvent.meta?.type === 'mission')
				.map((missionEvent) => missionEvent.meta?.mission?.id);
			solutionEvents = solutionEvents.filter(
				(missionEvent) =>
					missionIdsAlreadyDisplayed.indexOf(missionEvent.meta.mission.id) ===
					-1
			);
			// Filtre pour les réunions : en vue non alignée, on affiche uniquement celle de l'utilisateur connecté OU celle de l'employé sélectionné dans le filtre
			// en vue alignée, réunion pour tout le monde. MAIS missionParent filtrée dans tous les cas
			solutionEvents = solutionEvents.filter(
				(event) =>
					!(
						event.meta?.type === 'mission' &&
						(event.meta.mission as Mission).missionRequest?.missionType.type ===
							MISSION_TYPE_REUNION_TYPE &&
						(event.meta.mission as Mission).missionParent === null
					) // on enlève uniquement la mission parent des réunions
			);
			if (!this.isWeekViewAlignedActive) {
				const empIdToKeep = displayForEmp
					? this.navbarPlanning.selectedEmployeeInDropdown.id
					: this.currentLoggedInEmployeeId;
				solutionEvents = solutionEvents.filter(
					(event) =>
						!(
							event.meta?.type === 'mission' &&
							(event.meta.mission as Mission).missionRequest?.missionType
								.type === MISSION_TYPE_REUNION_TYPE &&
							(event.meta.employee as Employee).id !== empIdToKeep
						)
				);
			}
			// Filtre pour les missions groupées (synched) => SI vue alignée : masquer la mission de la planif ; SINON afficher uniquement la mission de la planif (missionParent)
			solutionEvents =
				this.isWeekViewAlignedActive || displayForEmp
					? solutionEvents.filter(
							(event) =>
								!(
									event.meta?.type === 'mission' &&
									(event.meta.mission as Mission).attendees
								)
					  )
					: solutionEvents.filter(
							(event) =>
								!(
									event.meta?.type === 'mission' &&
									(event.meta.mission.missionParent as Mission)?.attendees
								)
					  );
		}
		// Mise à jour de la liste des événements
		if (this.isWeekViewAlignedActive) {
			solutionEvents.forEach((event) => {
				const dataForDay = this.dataForWeekViewAligned.find(
					(data) => data.date.getDay() === event.start.getDay()
				);
				if (dataForDay) {
					dataForDay.events = [...dataForDay?.events, event];
				}
			});
		} else {
			this.events = [...this.events, ...solutionEvents];
		}
	}

	/**
	 * AVAILABILITY
	 */
	displayAvailabilities() {
		if (this.isModeAvailabilityActive.active) {
			this.logger.debug('displayAvailabilities');
			this.cleanPlanning('route_mission_vacation');
			this.isLoadingSolution = true;

			const availabilitiesEvents: CalendarEvent[] = [];

			// Les filtres sont gérés ici
			const displayForAllEmps: boolean =
				this.navbarPlanning?.ddEmployee === this.navbarPlanning?.defaultText;
			const displayForCareSkill: boolean =
				!displayForAllEmps && this.navbarPlanning?.selectedCompetenceInDropdown;
			const displayForEmp =
				!displayForAllEmps && this.navbarPlanning?.selectedEmployeeInDropdown;

			if (displayForAllEmps) {
				availabilitiesEvents.push(...this.eventsStore.availabilities);
			} else if (displayForCareSkill) {
				availabilitiesEvents.push(
					...this.eventsStore.availabilities.filter((ev) =>
						ev.meta?.employee?.careSkill?.name.includes(
							this.navbarPlanning?.selectedCompetenceInDropdown.key
						)
					)
				);
			} else if (displayForEmp) {
				availabilitiesEvents.push(
					...this.eventsStore.availabilities.filter(
						(ev) =>
							ev.meta?.employee?.id ===
							this.navbarPlanning?.selectedEmployeeInDropdown.id
					)
				);
			}
			// Mise à jour de la liste des événements
			if (this.isWeekViewAlignedActive) {
				availabilitiesEvents.forEach((event) => {
					const dataForDay = this.dataForWeekViewAligned.find(
						(data) => data.date.getDay() === event.start.getDay()
					);
					if (dataForDay) {
						dataForDay.events = [...dataForDay?.events, event];
					}
				});
				// compléter la liste d'emp avec les emps dispo toute la journée
				this.dataForWeekViewAligned.forEach((dataForDay) => {
					const allDayEvents = dataForDay.events.filter(
						(event) => event.meta?.type === 'allDayAvailability'
					);
					allDayEvents.forEach((event) => {
						event.allDay = false;
						const end = new Date(event.start);
						end.setHours(23, 59, 59);
						event.end = end;
					});
					const empsAvailableAllDay = [
						...new Map(
							[...allDayEvents.map((event) => event.meta?.employee)].map(
								(v) => [v.id, v]
							)
						).values()
					];
					dataForDay.employees.push(...empsAvailableAllDay);
				});
			} else {
				this.events = [...this.events, ...availabilitiesEvents];
				this.events
					.filter((event) => event.meta?.type === 'allDayAvailability')
					.forEach((event) => {
						event.allDay = true;
						event.end = null;
					});
			}
		}
	}

	async getAllAvailabilities(): Promise<Array<CalendarEvent>> {
		return new Promise((resolve, reject) => {
			this.facade.availabilityService
				.getAllAvailability(this.selectedYear, this.selectedWeek)
				.subscribe({
					next: (availabilityEventList) => {
						availabilityEventList.forEach((ev: CalendarEvent) => {
							ev.start = new Date(ev.start);
							// si l'event est de type allDay : pas de fin, et pas de couleur
							if (!ev.allDay) {
								ev.color = this.convertObjectToCalEv.getColorFromEmployee(
									ev.meta.employee
								);
								ev.end = new Date(ev.end);
							}
							ev.resizable = {
								beforeStart: false,
								afterEnd: false
							};
						});
						resolve(availabilityEventList);
					},
					error: (err: ErrorResponse) => {
						this.facade.toastService.createHttpErrorToast(
							err.error.response,
							err.status
						);
						reject(err.error.response);
					}
				});
		});
	}

	/**
	 * Récupère/Met à jour les disponibilités
	 * @param displayEvents
	 */
	async updateAvailabilities(displayEvents?: boolean) {
		this.logger.debug('updateAvailabilities');
		this.setIsLoadingSolutionAndTriggerChangeDetection(true);

		this.eventsStore.availabilities.length = 0; // reset liste des availabilities
		this.eventsStore.availabilities = await this.getAllAvailabilities();
		if (displayEvents) {
			this.displayAvailabilities();
			this.updateEmployeeForWeekView();
		}
		this.setIsLoadingSolutionAndTriggerChangeDetection(false);
	}

	/**
	 * Test si la création d'absence est possible
	 * @returns
	 */
	isDragToCreatePossible(): boolean {
		return (
			this.navbarPlanning.isAbsenceSwitchActive &&
			!this.isMobile &&
			this.isPlanningEditable &&
			this.isPlanificatrice &&
			!this.isModeAvailabilityActive.active
		);
	}

	/** Création absence en vue classique */
	startDragToCreate(
		viewDate: Date,
		weekStartsOn: DAYS_OF_WEEK,
		segment: WeekViewHourSegment,
		mouseDownEvent: MouseEvent,
		segmentElement: HTMLElement
	) {
		if (this.isDragToCreatePossible()) {
			this.dragToSelectEvent = null;
			this.dragToSelectEvent = {
				id: this.events.length,
				title: 'Nouvelle absence',
				start: segment.date,
				resizable: {
					beforeStart: false,
					afterEnd: false
				},
				draggable: false,
				meta: {
					type: 'temp',
					tmpEvent: true,
					vacation: new Vacation()
				},
				color: this.convertObjectToCalEv.colors.lightgrey
			};
			this.events = [...this.events, this.dragToSelectEvent];
			const segmentPosition = segmentElement.getBoundingClientRect();
			this.dragToCreateActive = true;
			const endOfView = endOfWeek(viewDate, {
				weekStartsOn
			});

			fromEvent(document, 'mousemove')
				.pipe(
					finalize(() => {
						delete this.dragToSelectEvent.meta.tmpEvent;
						if (!this.dragToSelectEvent.end) {
							this.dragToSelectEvent.end = addMinutes(
								this.dragToSelectEvent.start,
								30
							);
						}
						this.dragToCreateActive = false;
						if (this.dragToSelectEvent.meta?.employee) {
							this.createAbsence.openCreateAbsenceModal(
								this.dragToSelectEvent.meta?.employee
							);
						} else {
							this.createAbsence.openCreateAbsenceModal();
						}
						this.refreshFunc();
					}),
					takeUntil(fromEvent(document, 'mouseup'))
				)
				.subscribe((mouseMoveEvent: MouseEvent) => {
					const minutesDiff = this.ceilToNearest(
						mouseMoveEvent.clientY - segmentPosition.top,
						30
					);

					const daysDiff =
						this.floorToNearest(
							mouseMoveEvent.clientX - segmentPosition.left,
							segmentPosition.width
						) / segmentPosition.width;

					const newEnd = addDays(
						addMinutes(segment.date, minutesDiff),
						daysDiff
					);
					if (newEnd > segment.date && newEnd < endOfView) {
						this.dragToSelectEvent.end = newEnd;
					}
					this.refreshFunc();
				});
		}
	}

	/** Création absence en vue alignée */
	startDragToCreateForAlignedView({ segment, employeeId }, date: Date) {
		if (this.isDragToCreatePossible()) {
			const employee = this.getEmployeeListFiltered(date).find(
				(emp) => emp.id === employeeId
			);

			this.dragToSelectEvent = {
				id: this.events.length,
				title: 'Nouvelle absence',
				start: segment.date,
				end: null,
				resizable: {
					beforeStart: false,
					afterEnd: false
				},
				draggable: false,
				meta: {
					type: 'temp',
					tmpEvent: true,
					vacation: new Vacation(),
					employee
				},
				color: this.convertObjectToCalEv.colors.lightgrey
			};
			const startMinutes = this.dateUtils.convertFromDateToMinutes(
				this.dragToSelectEvent.start
			);

			const dateOfWeek = this.dataForWeekViewAligned.find(
				(dateOfWeek) => dateOfWeek.date.getDay() === date.getDay()
			);
			dateOfWeek.events = [...dateOfWeek.events, this.dragToSelectEvent];

			let dragToCreateActive = true;
			const weekStartsOn = 1;
			const endOfView = endOfWeek(
				new Date(), //view date
				{
					weekStartsOn
				}
			);

			fromEvent(document, 'mousemove')
				.pipe(
					finalize(() => {
						delete this.dragToSelectEvent.meta.tmpEvent;
						if (!this.dragToSelectEvent.end) {
							this.dragToSelectEvent.end = addMinutes(
								this.dragToSelectEvent.start,
								30
							);
						}
						dragToCreateActive = false;
						this.createAbsence.openCreateAbsenceModal(
							this.dragToSelectEvent.meta.employee
						);
						this.refreshFunc(date);
					}),
					takeUntil(fromEvent(document, 'mouseup'))
				)
				.subscribe((mouseMoveEvent: MouseEvent) => {
					const newEndMinutes = this.ceilToNearest(
						mouseMoveEvent.pageY + 30,
						30
					);
					const minutesDiff = newEndMinutes - startMinutes;

					const newEnd = addMinutes(segment.date, minutesDiff);
					if (this.dragToSelectEvent.start.getTime() < newEnd.getTime()) {
						this.dragToSelectEvent.end = newEnd;
					}
					this.refreshFunc(date);
				});
		}
	}

	private refreshFunc(date?: Date) {
		if (date) {
			const dateOfWeek = this.dataForWeekViewAligned.find(
				(dateOfWeek) => dateOfWeek.date.getDay() === date.getDay()
			);
			dateOfWeek.events = [...dateOfWeek.events];
		} else {
			this.events = [...this.events];
		}
		this.cdr.detectChanges();
	}

	floorToNearest(amount: number, precision: number) {
		return Math.floor(amount / precision) * precision;
	}

	ceilToNearest(amount: number, precision: number) {
		return Math.ceil(amount / precision) * precision;
	}

	/**
	 * Vue mois
	 * @param param0
	 * @param selectedCalendarDate
	 */
	dayClicked(
		{
			date,
			events
		}: {
			date: Date;
			events: CalendarEvent[];
		},
		selectedCalendarDate: Date
	): void {
		// if (isSameMonth(date, selectedCalendarDate)) {
		// 	if (
		// 		(isSameDay(selectedCalendarDate, date) &&
		// 			this.activeDayIsOpen === true) ||
		// 		events.length === 0
		// 	) {
		// 		this.activeDayIsOpen = false;
		// 	} else {
		// 		this.activeDayIsOpen = true;
		// 	}
		// 	this.selectedCalendarDate = date;
		// }
	}

	/** Zoom planning : vertical (horaires) */
	changeHourSegments(operation?: string) {
		if (operation === '+' && this.hourSegments < this.hourSegmentsMax) {
			this.hourSegments++;
		} else if (operation === '-' && this.hourSegments > this.hourSegmentsMin) {
			this.hourSegments--;
		}
	}

	/** Zoom planning : +/- de jours à afficher */
	addOrRemoveDay(operation?: string) {
		const maxDayToDisplay = 5;
		if (operation === '+' && this.nbDayToDisplay < maxDayToDisplay) {
			this.nbDayToDisplay++;
		} else if (operation === '-' && this.nbDayToDisplay > 1) {
			this.nbDayToDisplay--;
		}
	}

	setAndSortListBeneficiaires() {
		// Liste des bénéficiaire
		this.listBeneficiaires = this.solution.plannings
			.flatMap((planning) => planning.routes)
			.flatMap((route) => route.missions)
			.map((mission) => mission.missionRequest.beneficiaire);

		this.listBeneficiaires = [
			...new Map(
				[
					...this.listBeneficiaires,
					...this.solution.unassignedMissions.map(
						(mission) => mission.missionRequest?.beneficiaire
					)
				]
					.filter((benef) => benef)
					.map((v) => [v.id, v])
			).values()
		];

		this.listBeneficiaires.sort(this.sortBeneficiaire);
	}

	setIsLoadingSolutionAndTriggerChangeDetection(isLoading: boolean): void {
		this.isLoadingSolution = isLoading;
		this.refreshInProgress = isLoading;
		//RELOAD HERE
		this.cdr.detectChanges();
	}

	checkIfOptimInProgress(notification: Notification) {
		let optimQueueOfSessionStorage =
			this.facade.dataStorageService.getOptimQueue();
		const optimQueueFromServer = notification.optimNotifications;

		if (
			optimQueueFromServer?.length > 0 ||
			optimQueueOfSessionStorage?.length > 0
		) {
			// si sessionStorage vide => sessionStorage = données du serveur
			if (
				!optimQueueOfSessionStorage ||
				optimQueueOfSessionStorage.length === 0
			) {
				optimQueueOfSessionStorage = optimQueueFromServer;
				this.facade.dataStorageService.setOptimQueue(optimQueueFromServer);
			}

			optimQueueOfSessionStorage.forEach((optimNotif) => {
				// cas où notif du serveur absente et notif localStorage présente => l'optim est terminée
				if (
					optimQueueFromServer ||
					optimQueueFromServer.findIndex(
						(optimQueue) =>
							optimQueue.year === optimNotif.year &&
							optimQueue.weekNumber === optimNotif.weekNumber
					) !== -1 ||
					optimQueueFromServer.length !== 0
				) {
					if (optimNotif.inProgress || optimNotif.waiting) {
						// Si la semaine qu'on regarde est en cours de planification
						if (optimNotif.weekNumber === this.solution.weekNumber) {
							this.setIsLoadingSolutionAndTriggerChangeDetection(true);
						} else {
							this.setIsLoadingSolutionAndTriggerChangeDetection(false);
						}
					} else {
						this.setIsLoadingSolutionAndTriggerChangeDetection(false);
					}
				}
			});
		} else {
			// Rien en storage, pas d'optim en cours
			// this.setIsLoadingSolutionAndTriggerChangeDetection(false);
		}
	}

	/**
	 * récupère les types de mission depuis la solution
	 */
	getMissionTypesFromSolution() {
		this.listMissionTypes = [
			...new Map(
				[
					...this.solution.plannings
						.flatMap((planning) => planning.routes)
						.flatMap((route) => route.missions),
					...this.solution.unassignedMissions
				]
					.map((mission) => mission.missionRequest.missionType)
					.map((v) => [v.id, v])
			).values()
		];
	}

	getCenterDepartmentsFromSolution() {
		const allMissions = [
			...this.solution.plannings
				.flatMap((planning) => planning.routes)
				.flatMap((route) => route.missions),
			...this.solution.unassignedMissions
		];

		const centerDepartments = allMissions
			.map((mission) => mission.missionRequest.centerDepartment)
			.filter((cd) => !!cd); // filtre les null/undefined

		this.listCenterDepartments = [
			...new Map(centerDepartments.map((cd) => [cd.id, cd])).values()
		];
	}

	/**
	 * récupère les missionPlace depuis la solution
	 */
	getMissionPlacesFromSolution() {
		this.listMissionPlaces = [
			...new Map(
				[
					...this.solution.plannings
						.flatMap((planning) => planning.routes)
						.flatMap((route) => route.missions),
					...this.solution.unassignedMissions
				]
					.filter((mission) => mission.missionRequest.missionPlace)
					.map((mission) => mission.missionRequest.missionPlace)
					.map((v) => [v.id, v])
			).values()
		];
	}

	/**
	 * Retire des employés lors d'un filtre emp/skill/benef/type mission
	 */
	updateEmployeeForWeekView() {
		this.logger.debug('updateEmployeeForWeekView');
		const fictiveEmp = new Employee({
			firstName: 'Non',
			lastName: 'affectées'
		});
		this.dataForWeekViewAligned.forEach((data) => {
			data.employees = [
				...new Map(
					[...data.employees, ...this.employeesList, fictiveEmp].map((v) => [
						v.id,
						v
					])
				).values()
			];
			data.employees = data.employees.filter((emp) => {
				if (!emp.id) {
					// il s'agit de la colonne "Non affectées"
					// on ne la garde que si elle contient au moins un élément
					return data.events.some(
						(event) => event.meta?.mission && !event.meta?.employee
					);
				} else {
					// au moins 1 event (mission/route/absence)
					return data.events.some(
						(event) => event.meta?.employee?.id === emp.id
					);
				}
			});
			if (data.employees.length === 0) {
				data.employees.push(fictiveEmp);
			}
			data.employees.sort(this.sortEmployeeByFirstNameAndIgnoreNonAffecte);
		});
	}

	hasEmpVacationsForDate(emp: Employee, date?: Date): boolean {
		if (emp.vacations && emp.vacations.length > 0) {
			if (date) {
				if (
					emp.vacations.some(
						(vac) =>
							this.isSameDay(new Date(vac.startDate), date) ||
							this.isSameDay(new Date(vac.endDate), date)
					)
				) {
					return true;
				}
			} else {
				const selectedDay = this.dateUtils.getMonday(this.selectedCalendarDate);
				for (let i = 0; i < 7; i++) {
					const testedDay = this.dateUtils.addDays(selectedDay, i);
					if (
						emp.vacations.some(
							(vac) =>
								this.isSameDay(vac.startDate, testedDay) ||
								this.isSameDay(vac.endDate, testedDay)
						)
					) {
						return true;
					}
				}
			}
		}
		return false;
	}

	isSameDay(date1: Date, date2: Date): boolean {
		if (
			date1.getFullYear() === date2.getFullYear() &&
			date1.getMonth() === date2.getMonth() &&
			date1.getDay() === date2.getDay()
		) {
			return true;
		}
		return false;
	}

	/**
	 * Retourne une liste d'employés filtrés pour une date et trié A-Z
	 * @param date
	 * @param forceFilterForWeekViewAligned
	 * @returns
	 */
	getEmployeeListFiltered(
		date?: Date,
		forceFilterForWeekViewAligned?: boolean
	) {
		this.logger.debug('getEmployeeListFiltered');
		let employeeListFiltered = this.employeesList;

		if (
			(this.navbarPlanning?.isAlignedWeekViewSwitchActive ||
				forceFilterForWeekViewAligned) &&
			date
		) {
			employeeListFiltered = this.solution?.plannings
				.filter((plan) => {
					const route = plan.routes.find(
						(routeIn) => new Date(routeIn.date).getDay() === date.getDay()
					);
					const missionsWithoutGroupedMissions = route?.missions.filter(
						(mission) => !mission.attendees
					);
					const hasRouteOnlyGroupedMissions =
						missionsWithoutGroupedMissions &&
						missionsWithoutGroupedMissions.length === 0;
					if (
						route &&
						route.missions.length > 0 &&
						(!hasRouteOnlyGroupedMissions ||
							this.isModeAvailabilityActive.active)
					) {
						return true;
					} else {
						return false;
					}
				})
				.map((plan) => plan.employee);

			if (this.isAbsenceSwitchActive()) {
				const empListWithVacations = this.employeesList.filter((emp) =>
					this.hasEmpVacationsForDate(emp, date)
				);
				employeeListFiltered = [
					...new Map(
						[...employeeListFiltered, ...empListWithVacations].map((v) => [
							v.id,
							v
						])
					).values()
				];
			}

			if (!this.isModeAvailabilityActive?.active) {
				// pas de colonne non affectées pour la vue dispo
				let existUnassignedMission =
					this.solution.unassignedMissions?.filter(
						(mission) =>
							new Date(mission.missionRequest.date).getDay() === date.getDay()
					).length > 0;

				if (existUnassignedMission || employeeListFiltered.length === 0) {
					const fictiveEmp = new Employee({
						firstName: 'Non',
						lastName: 'affectées'
					});
					if (
						employeeListFiltered.findIndex(
							(emp) => emp.firstName === 'Non' && emp.lastName === 'affectées'
						) === -1
					) {
						employeeListFiltered.push(fictiveEmp);
					}
				}
			}
		}

		employeeListFiltered.sort(this.sortEmployeeByFirstNameAndIgnoreNonAffecte);

		return employeeListFiltered;
	}

	private sortEmployeeByFirstNameAndIgnoreNonAffecte = (
		emp1: Employee,
		emp2: Employee
	) => {
		if (!emp1.id || !emp2.id) {
			return 0;
		}
		return emp1.firstName.localeCompare(emp2.firstName);
	};

	private sortBeneficiaire(benef1: Beneficiaire, benef2: Beneficiaire) {
		if (benef1.firstName < benef2.firstName) {
			return -1;
		}
		if (benef1.firstName > benef2.firstName) {
			return 1;
		}
		return 0;
	}

	//Evenement de la vue liste
	receiveListEvent(event) {
		const missionId = event.id;
		const eventsListToUse = this.isWeekViewAlignedActive
			? this.dataForWeekViewAligned.flatMap((data) => data.events)
			: this.events;
		this.listViewEvent = eventsListToUse.find(
			(event) =>
				event.meta?.type === 'mission' && event.meta?.mission.id === missionId
		);
		if (!this.listViewEvent) {
			this.listViewEvent =
				this.convertObjectToCalEv.convertMissionToCalendarEvent(
					this.findMissionInSolutionById(missionId)
				);
		}
		this.eventEdit.handleEvent('listView', this.listViewEvent, missionId);
	}

	findMissionInSolutionById(missionId: number) {
		const missions = [
			...this.solution.plannings
				.flatMap((planning) => planning.routes)
				.flatMap((route) => route.missions),
			...this.solution.unassignedMissions
		];
		return missions.find((mission) => mission.id === missionId);
	}

	formatDateHeaderWeekViewAligned(data: {
		date: Date;
		isHoliday: boolean;
		employees: Employee[];
		events: CalendarEvent[];
	}) {
		// if jour férié alors : mettre balise à true dans dataForWeekViewAligned + ajouter (férié)

		return (
			this.daysFr[data.date.getDay()] +
			' - ' +
			data.date.toLocaleDateString('fr-FR').slice(0, 5)
		);
	}

	isDateHoliday(date: Date): boolean {
		for (let holy in this.convertObjectToCalEv.publicHolidays) {
			if (holy === this.dateUtils.convertFromDateToDateWithDash(date)) {
				return true;
			}
		}
		return false;
	}

	/**
	 * Actualise la vue du planning
	 *
	 * @param objRefresh
	 */
	refreshView(objRefresh?: { resetDataNeeded: boolean }) {
		this.logger.debug('refreshView');
		this.setIsLoadingSolutionAndTriggerChangeDetection(true);
		let stopLoader = true;
		// Si les données ont été reset (appel depuis getData), on met à jour la structure de données (changement de dates)
		const isResetDataStructureNeeded =
			this.isWeekViewAlignedActive && objRefresh && objRefresh.resetDataNeeded;
		if (isResetDataStructureNeeded) {
			this.initDataStructureForAlignedView();
		}
		// Si vue disponibilités
		if (this.isModeAvailabilityActive.active) {
			const isDataAvailabilityAvailable = !(
				(objRefresh && objRefresh.resetDataNeeded) ||
				this.eventsStore.availabilities.length === 0
			);
			if (!isDataAvailabilityAvailable) {
				// Les données ne sont pas disponibles, on les récupère et on force l'affichage
				const displayEvents = true;
				this.updateAvailabilities(displayEvents);
				// pas besoin de stopper le loader ici, il se stoppera a la fin du subscribe de updateAvailabilities.
				stopLoader = false;
			} else {
				// Les données sont déjà disponibles, on les affiche
				this.displayAvailabilities();
			}
		} else {
			// Vue classique, on affiche la solution et les absences
			this.displaySolution();
			this.displayVacations();
		}
		if (this.isWeekViewAlignedActive) {
			// Mise à jour de la liste d'employés filtrer les colonnes vides
			this.updateEmployeeForWeekView();
		} else {
			// On n'affiche pas les events de trajet en vue non alignée (sinon affichage complètement décalé et entassements d'events)
			this.events = this.events.filter(
				(event) => event.meta?.type !== 'travel'
			);
		}
		if (stopLoader) {
			this.setIsLoadingSolutionAndTriggerChangeDetection(false);
		}
	}

	/**
	 * initialise la structure de données pour la vue alignée
	 * on préremplit les dates et indique s'il s'agit d'un jour férié
	 */
	initDataStructureForAlignedView() {
		this.logger.debug('initDataStructureForAlignedView');
		let monday = this.dateUtils.getMonday(this.selectedCalendarDate);
		const nbDay = 6;
		this.dataForWeekViewAligned = [];
		for (let i = 0; i < nbDay; i++) {
			const date = this.dateUtils.addDays(monday, i);
			const employees = [];
			const events = [];
			const isHoliday = this.isDateHoliday(date);
			this.dataForWeekViewAligned.push({ date, isHoliday, employees, events });
		}
	}

	/**
	 * Récupère la solution, les employés/absences, l'état de l'optim
	 * + changement de vue afficher/masquer weekend en non aligné
	 * @param objRefresh
	 * @returns
	 */
	getDataForPlanning(objRefresh?: {
		dateToLoad?: Date;
		changeDisplayWeekend?: boolean;
		reloadSolution?: boolean;
		reloadEmployeesAndVacation?: boolean;
		reloadOptimInProgress?: boolean;
		busUnsubscribe?: boolean;
		reloadVacationTypes?: boolean;
	}): void {
		this.logger.debug('getDataForPlanning');

		if (this.eventBusSub && objRefresh.busUnsubscribe) {
			this.eventBusSub.unsubscribe();
			this.isEventBusLaunched = false;
		}

		this.isLoadingSolution = true;
		this.refreshInProgress = true;

		if (objRefresh?.dateToLoad) {
			this.selectedCalendarDate = objRefresh.dateToLoad;
		}

		this.selectedWeek = this.dateUtils.getWeekNumber(this.selectedCalendarDate);
		// Sauvegarde le numéro de semaine pour les stats
		this.facade.dataStorageService.setParam(
			'statWeekNumber',
			this.selectedWeek
		);

		this.excludeDays = this.navbarPlanning?.isWeekendActive ? [] : [0, 6];

		if (objRefresh?.changeDisplayWeekend) {
			// lors de l'event "changeSwitchWeekend" : pas besoin de recharger la solution => return
			this.isLoadingSolution = false;
			this.refreshInProgress = false;
			return;
		}

		if (this.isModeListActive.active || this.isModeAvailabilityActive.active) {
			this.view = CalendarView.Week;
		}

		let eventsToClean = '';
		if (objRefresh?.reloadSolution) {
			eventsToClean += 'mission_route_availability';
			this.facade.cacheService.clearCache();
		}
		if (objRefresh?.reloadEmployeesAndVacation) {
			eventsToClean += 'vacation';
		}
		if (eventsToClean !== '') {
			this.cleanPlanning(eventsToClean);
		}
		// Ajout des jours fériés
		this.addPublicHolidaysToCalendarEvent();

		const serviceCenterIdToUse = this.selectedCenter
			? this.selectedCenter.id
			: this.currentUser.employee.serviceCenter.id;

		// Patch au cas où c'est undefined
		if (!objRefresh?.reloadVacationTypes) {
			objRefresh.reloadVacationTypes = false;
		}

		this.facade.planningService
			.getAllInformationToDisplayPlanning(
				serviceCenterIdToUse,
				this.selectedCalendarDate.getFullYear(),
				this.selectedWeek,
				{
					withSolution: objRefresh?.reloadSolution,
					withEmployees: objRefresh?.reloadEmployeesAndVacation,
					withNotifications: objRefresh?.reloadOptimInProgress,
					withVacationTypes: objRefresh?.reloadVacationTypes
				}
			)
			.subscribe((planningInformation: PlanningInformation) => {
				this.isLoadingSolution = false;
				this.refreshInProgress = false;

				if (planningInformation.employees) {
					this.employeesList = planningInformation.employees;
					if (!planningInformation.solution) {
						this.storeEventsVacations();
						this.refreshView({ resetDataNeeded: true });
					}
				}

				if (planningInformation.solution) {
					this.solutions = null;
					this.logger.debug('reset solution !');
					this.logger.log(
						`solution for week ${this.selectedWeek} found -> ${planningInformation.solution.plannings?.length} 
						plannings & ${planningInformation.solution.unassignedMissions.length} unassigned missions loaded`
					);
					this.solution = planningInformation.solution;
					this.setAndSortListBeneficiaires();
					this.getMissionTypesFromSolution();
					this.getCenterDepartmentsFromSolution();
					this.getMissionPlacesFromSolution();
					this.storeEvents();
					this.refreshView({ resetDataNeeded: true });
				}

				if (planningInformation.notification) {
					this.checkIfOptimInProgress(planningInformation.notification);
				}

				if (planningInformation.vacationTypes) {
					this.vacationTypes = planningInformation.vacationTypes;
				}

				if (
					this.facade.dataStorageService.isOptimMultipleActive() &&
					this.facade.dataStorageService.getParam('openReport')
				) {
					this.facade.dataStorageService.deleteParam('openReport');
					this.navbarPlanning?.getTemporaryOptimReports();
				}
			});
	}

	/**
	 * Utiliser par la navbar planning pour ajouter une absence
	 */
	openCreateVacationModale() {
		const start = new Date();
		start.setHours(8);
		start.setMinutes(0);
		const end = new Date();
		end.setHours(10);
		end.setMinutes(0);

		this.dragToSelectEvent = null;
		this.dragToSelectEvent = {
			id: this.events.length,
			title: 'Nouvelle absence',
			start: start,
			end: end,
			resizable: {
				beforeStart: false,
				afterEnd: false
			},
			draggable: false,
			meta: {
				vacation: new Vacation()
			},
			color: this.convertObjectToCalEv.colors.lightgrey
		};

		this.createAbsence.openCreateAbsenceModal();
	}
}
